import {useEffect} from "react";
import ApiService from "../../../services/ApiService";
import {useDataGrid} from "../../../components/data-grid/DataGridContext";
import DataGrid from "../../../components/data-grid/DataGrid";

export default function AdminCompareHistory({userId}) {
    const {setData, setPaginationResult, queryModel, setDataGridProps} = useDataGrid();

    const initGridData = async () => {
        if(userId) {
            queryModel.filter = {
                userId
            }
        } else {
            queryModel.filter = {}
        }

        const response = await ApiService.AdminDashboard.GetCompareHistoryGrid(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel, userId])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'operationKey',
            enableRowSelection: false,
            columns: [
                {title: 'Date', dataIndex: 'createdDate', key: 'createdDate', sorter: false, render: (text, record) => `${new Date(text).toLocaleString()}`},
                {title: 'Name', dataIndex: 'name', key: 'name', sorter: false},
                {title: 'Lastname', dataIndex: 'lastname', key: 'lastname', sorter: false},
                {title: 'Email', dataIndex: 'email', key: 'email', sorter: false,},
                {title: 'Base Project', dataIndex: 'baseProjectTitle', key: 'baseProjectTitle', sorter: false},
                {title: 'Base Plan', dataIndex: 'basePlanTitle', key: 'basePlanTitle', sorter: false},
                {title: 'Comparison Project', dataIndex: 'compareProjectTitle', key: 'compareProjectTitle', sorter: false},
                {title: 'Comparison Plan', dataIndex: 'comparePlanTitle', key: 'comparePlanTitle', sorter: false},
                {title: 'Message Count', dataIndex: 'messageCount', key: 'messageCount', sorter: false},
            ]
        })
    }, [])

    return (
        <>
            <DataGrid />
        </>
    )
}